/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsDocumentType interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsDocumentType(value) {
    if (!('Value' in value) || value['Value'] === undefined)
        return false;
    if (!('NeedUserAcceptance' in value) || value['NeedUserAcceptance'] === undefined)
        return false;
    return true;
}
export function FxIdDomainEntitiesDocumentsDocumentTypeFromJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentTypeFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Value': json['Value'],
        'NeedUserAcceptance': json['NeedUserAcceptance'],
    };
}
export function FxIdDomainEntitiesDocumentsDocumentTypeToJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentTypeToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentTypeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Value': value['Value'],
        'NeedUserAcceptance': value['NeedUserAcceptance'],
    };
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsDocumentType.js.map